import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';
import Icon from '../../components/AppIcon';
import Button from '../../components/ui/Button';
import MotorcycleSelector from './components/MotorcycleSelector';
import FinancingForm from './components/FinancingForm';
import SimulationResult from './components/SimulationResult';
import RequiredDocuments from './components/RequiredDocuments';
import FAQSection from './components/FAQSection';

const CreditSimulation = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const [selectedMotorcycle, setSelectedMotorcycle] = useState(null);
  const [formData, setFormData] = useState({
    downPayment: '',
    quickDownPayment: '',
    tenor: '',
    fullName: '',
    phone: '',
    email: ''
  });
  const [simulationResult, setSimulationResult] = useState(null);

  const motorcycles = 
  [
  {
    id: 1,
    name: "Honda BeAT",
    type: "Skutik Matic",
    price: 19174000,
    image: "/assets/motor/HondaBeAT.webp",
    imageAlt: "Red Honda BeAT scooter parked on urban street with modern buildings in background",
    isPopular: true
  },
  {
    id: 2,
    name: "Honda Vario 160",
    type: "Skutik Premium",
    price: 28342000,
    image: "/assets/motor/HondaVario160.webp",
    imageAlt: "Silver Honda Vario 160 premium scooter displayed in showroom with bright lighting",
    isPopular: true
  },
  {
    id: 3,
    name: "Honda PCX 160",
    type: "Skutik Premium",
    price: 34592000,
    image: "/assets/motor/PcxExceptionalRedCBS.webp",
    imageAlt: "White Honda PCX 160 luxury scooter parked in modern urban setting with glass buildings",
    isPopular: false
  },

  // === Tambahan mulai sini ===

  {
    id: 4,
    name: "Honda Vario 125",
    type: "Skutik Matic",
    price: 25153000,
    image: "/assets/motor/HondaVario125.avif",
    imageAlt: "Black Honda Vario 125 scooter displayed in modern showroom environment",
    isPopular: true
  },
  {
    id: 5,
    name: "Honda ADV 160",
    type: "Skutik Adventure",
    price: 37459000,
    image: "/assets/motor/HondaAdv.webp",
    imageAlt: "Grey Honda ADV 160 adventure scooter parked on rugged outdoor terrain",
    isPopular: true
  },
  {
    id: 6,
    name: "Honda Stylo 160",
    type: "Skutik Retro",
    price: 29463000,
    image: "/assets/motor/HondaStylo.webp",
    imageAlt: "Green Honda Stylo 160 retro scooter displayed in stylish urban cafe setting",
    isPopular: false
  },
  {
    id: 7,
    name: "Honda Supra X 125",
    type: "Bebek Sport",
    price: 21544000,
    image: "/assets/motor/HondaSuprax125.webp",
    imageAlt: "Black Honda Supra X 125 cub motorcycle on asphalt road with mountain background",
    isPopular: false
  },
  {
    id: 8,
    name: "Honda Revo",
    type: "Bebek Sport",
    price: 18179000,
    image: "/assets/motor/HondaRevo.webp",
    imageAlt: "Honda Revo bebek sport dengan desain ramping dan irit bahan bakar, cocok untuk penggunaan harian",
    isPopular: false
  },
  {
    id: 9,
    name: "Honda CB150X",
    type: "Sport Adventure",
    price: 35214000,
    image: "/assets/motor/HondaCB.jpg",
    imageAlt: "Black Honda CB150X adventure sport motorcycle parked on open landscape road",
    isPopular: true
  },
  {
    id: 10,
    name: "Honda EM1 e:",
    type: "Motor Listrik",
    price: 40000000,
    image: "/assets/motor/HondaEM1e.webp",
    imageAlt: "White Honda EM1 e electric scooter displayed in futuristic showroom",
    isPopular: false
  },
  {
    id: 11,
    name: "Honda ICON e:",
    type: "Motor Listrik",
    price: 28000000,
    image: "/assets/motor/HondaICONe.avif",
    imageAlt: "Compact Honda ICON e electric scooter in minimal modern setting",
    isPopular: false
  },
  {
    id: 12,
    name: "Honda CUV e:",
    type: "Motor Listrik",
    price: 54450000,
    image: "/assets/motor/HondaCUVe.webp",
    imageAlt: "Honda CUV e electric urban vehicle parked in smart city environment",
    isPopular: false
  }
]

  const tenorOptions = [
  { value: '12', label: '12 Bulan' },
  { value: '18', label: '18 Bulan' },
  { value: '24', label: '24 Bulan' },
  { value: '30', label: '30 Bulan' },
  { value: '36', label: '36 Bulan' }];


  const downPaymentOptions = [
  { value: '2000000', label: 'Rp 2.000.000' },
  { value: '3000000', label: 'Rp 3.000.000' },
  { value: '5000000', label: 'Rp 5.000.000' },
  { value: '7000000', label: 'Rp 7.000.000' },
  { value: '10000000', label: 'Rp 10.000.000' }];


  const requiredDocuments = [
  {
    icon: 'CreditCard',
    title: 'KTP (Kartu Tanda Penduduk)',
    description: 'Fotokopi KTP yang masih berlaku'
  },
  {
    icon: 'Users',
    title: 'Kartu Keluarga',
    description: 'Fotokopi Kartu Keluarga terbaru'
  },
  {
    icon: 'FileText',
    title: 'Slip Gaji / NPWP',
    description: 'Bukti penghasilan 3 bulan terakhir'
  },
  {
    icon: 'Home',
    title: 'Bukti Tempat Tinggal',
    description: 'Rekening listrik/air/telepon'
  },
  {
    icon: 'Briefcase',
    title: 'Surat Keterangan Kerja',
    description: 'Dari perusahaan tempat bekerja'
  },
  {
    icon: 'Building',
    title: 'SIUP (Untuk Wiraswasta)',
    description: 'Surat Izin Usaha Perdagangan'
  }];


  const faqs = [
  {
    question: "Berapa minimal uang muka (DP) yang harus dibayar?",
    answer: "Minimal uang muka adalah 10% dari harga motor. Namun, semakin besar DP yang Anda bayarkan, cicilan bulanan akan semakin ringan. Kami menyarankan DP minimal 20-30% untuk cicilan yang lebih nyaman."
  },
  {
    question: "Berapa lama proses persetujuan kredit?",
    answer: "Proses persetujuan kredit biasanya memakan waktu 1-2 hari kerja setelah dokumen lengkap diterima. Untuk kasus tertentu, persetujuan bisa lebih cepat dalam hitungan jam jika semua dokumen sudah lengkap dan memenuhi syarat."
  },
  {
    question: "Apakah bisa mengajukan kredit tanpa slip gaji?",
    answer: "Ya, bisa. Untuk yang tidak memiliki slip gaji (wiraswasta/freelance), Anda bisa menggunakan dokumen alternatif seperti rekening koran 3 bulan terakhir, SIUP, atau surat keterangan penghasilan dari kelurahan."
  },
  {
    question: "Apakah ada biaya administrasi dan asuransi?",
    answer: "Ya, ada biaya administrasi dan asuransi yang akan ditambahkan ke total pembiayaan. Besarnya bervariasi tergantung leasing partner yang dipilih, biasanya berkisar 3-5% dari harga motor untuk biaya administrasi dan premi asuransi."
  },
  {
    question: "Bagaimana jika saya ingin melunasi kredit lebih cepat?",
    answer: "Anda bisa melakukan pelunasan dipercepat kapan saja. Namun, beberapa leasing menerapkan denda pelunasan dipercepat sekitar 2-5% dari sisa pokok. Silakan konsultasikan dengan tim kami untuk detail kebijakan masing-masing leasing."
  },
  {
    question: "Apakah motor bisa langsung dibawa pulang setelah DP?",
    answer: "Setelah DP dibayar dan kredit disetujui, motor bisa langsung dibawa pulang. Proses pengurusan STNK dan BPKB akan kami bantu hingga selesai. BPKB akan dipegang oleh leasing hingga kredit lunas."
  }];


  useEffect(() => {
    window.scrollTo(0, 0);
  }, [currentStep]);

  const calculateSimulation = () => {
    if (!selectedMotorcycle || !formData?.downPayment || !formData?.tenor) {
      return;
    }

    const price = selectedMotorcycle?.price;
    const dp = parseFloat(formData?.downPayment);
    const tenor = parseInt(formData?.tenor);

    const interestRates = {
      12: 8,
      18: 9,
      24: 10,
      30: 11,
      36: 12
    };

    const interestRate = interestRates?.[tenor] || 10;
    const principal = price - dp;
    const monthlyInterestRate = interestRate / 100 / 12;
    const monthlyPayment = Math.round(
      principal * monthlyInterestRate * Math.pow(1 + monthlyInterestRate, tenor) / (
      Math.pow(1 + monthlyInterestRate, tenor) - 1)
    );
    const totalPayment = monthlyPayment * tenor + dp;

    setSimulationResult({
      motorcycleName: selectedMotorcycle?.name,
      motorcyclePrice: price,
      downPayment: dp,
      tenor: tenor,
      interestRate: interestRate,
      monthlyPayment: monthlyPayment,
      totalPayment: totalPayment
    });

    setCurrentStep(3);
  };

  const handleWhatsAppConsult = () => {
    const message = `Halo Honda Pamulang, saya tertarik dengan hasil simulasi kredit:\n\nMotor: ${simulationResult?.motorcycleName}\nHarga: Rp ${simulationResult?.motorcyclePrice?.toLocaleString('id-ID')}\nDP: Rp ${simulationResult?.downPayment?.toLocaleString('id-ID')}\nTenor: ${simulationResult?.tenor} bulan\nCicilan: Rp ${simulationResult?.monthlyPayment?.toLocaleString('id-ID')}/bulan\n\nNama: ${formData?.fullName}\nTelepon: ${formData?.phone}\n\nMohon informasi lebih lanjut.`;

    window.open(`https://wa.me/6288293642972?text=${encodeURIComponent(message)}`, '_blank');
  };

  const handleReset = () => {
    setCurrentStep(1);
    setSelectedMotorcycle(null);
    setFormData({
      downPayment: '',
      quickDownPayment: '',
      tenor: '',
      fullName: '',
      phone: '',
      email: ''
    });
    setSimulationResult(null);
  };

  const steps = [
  { number: 1, title: 'Pilih Motor', icon: 'Bike' },
  { number: 2, title: 'Isi Data', icon: 'FileText' },
  { number: 3, title: 'Hasil Simulasi', icon: 'Calculator' }];


  return (
    <>
      <Helmet>
        <title>Simulasi Kredit Motor Honda - Honda Pamulang</title>
        <meta name="description" content="Hitung cicilan motor Honda dengan simulasi kredit online. Proses cepat, transparan, dan mudah. Dapatkan estimasi cicilan bulanan sesuai budget Anda." />
      </Helmet>
      <Header />
      <main className="bg-background min-h-screen" >
        <section className="bg-gradient-to-br from-primary to-accent text-primary-foreground py-12 md:py-16 lg:py-20" >
          <div className="container mx-auto px-4" data-aos="fade-up">
            <div className="max-w-4xl mx-auto text-center space-y-4">
              <div className="inline-flex items-center justify-center w-16 h-16 md:w-20 md:h-20 rounded-full bg-primary-foreground/10 mb-4">
                <Icon name="Calculator" size={32} color="white" strokeWidth={2} />
              </div>
              <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold">
                Simulasi Kredit Motor Honda
              </h1>
              <p className="text-base md:text-lg text-primary-foreground/90 max-w-2xl mx-auto">
                Hitung estimasi cicilan motor Honda impian Anda dengan mudah dan transparan. 
                Dapatkan hasil simulasi real-time sesuai budget Anda.
              </p>
            </div>
          </div>
        </section>

        <section className="py-8 md:py-12">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto">
              <div className="flex items-center justify-between mb-8 md:mb-12">
                {steps?.map((step, index) =>
                <React.Fragment key={step?.number}>
                    <div className="flex flex-col items-center space-y-2">
                      <div
                      className={`w-12 h-12 md:w-16 md:h-16 rounded-full flex items-center justify-center transition-all duration-300 ${
                      currentStep >= step?.number ?
                      'bg-primary text-primary-foreground shadow-honda-subtle' :
                      'bg-muted text-muted-foreground'}`
                      }>

                        <Icon
                        name={step?.icon}
                        size={24}
                        color={currentStep >= step?.number ? 'white' : 'var(--color-muted-foreground)'} />

                      </div>
                      <p className={`text-xs md:text-sm font-heading font-semibold text-center ${
                    currentStep >= step?.number ? 'text-primary' : 'text-muted-foreground'}`
                    }>
                        {step?.title}
                      </p>
                    </div>
                    {index < steps?.length - 1 &&
                  <div className={`flex-1 h-1 mx-2 md:mx-4 rounded transition-colors duration-300 ${
                  currentStep > step?.number ? 'bg-primary' : 'bg-muted'}`
                  } />
                  }
                  </React.Fragment>
                )}
              </div>
            </div>
          </div>
        </section>

        <section className="pb-12 md:pb-16 lg:pb-20">
          <div className="container mx-auto px-4">
            <div className="max-w-6xl mx-auto">
              {currentStep === 1 &&
              <div className="space-y-8">
                  <MotorcycleSelector
                  motorcycles={motorcycles}
                  selectedMotorcycle={selectedMotorcycle}
                  onSelect={setSelectedMotorcycle} />


                  <div className="flex justify-center" data-aos="fade-up" data-aos-delay="100">
                    <Button
                    variant="default"
                    size="lg"
                    iconName="ArrowRight"
                    iconPosition="right"
                    onClick={() => setCurrentStep(2)}
                    disabled={!selectedMotorcycle}
                    className="shadow-honda-subtle">

                      Lanjut ke Pengisian Data
                    </Button>
                  </div>
                </div>
              }

              {currentStep === 2 &&
              <div className="space-y-8">
                  <div className="bg-card border border-border rounded-lg p-6 md:p-8">
                    <div className="flex items-center space-x-4 mb-6 pb-6 border-b border-border">
                      <div className="w-16 h-16 md:w-20 md:h-20 rounded-lg overflow-hidden bg-muted flex-shrink-0">
                        <img
                        src={selectedMotorcycle?.image}
                        alt={selectedMotorcycle?.imageAlt}
                        className="w-full h-full object-cover" />

                      </div>
                      <div className="flex-1 min-w-0">
                        <p className="text-sm text-muted-foreground mb-1">Motor Pilihan</p>
                        <h3 className="text-lg md:text-xl font-heading font-bold text-foreground">
                          {selectedMotorcycle?.name}
                        </h3>
                        <p className="text-sm text-muted-foreground">{selectedMotorcycle?.type}</p>
                        <p className="text-lg font-heading font-bold text-primary mt-1">
                          Rp {selectedMotorcycle?.price?.toLocaleString('id-ID')}
                        </p>
                      </div>
                    </div>

                    <FinancingForm
                    formData={formData}
                    onFormChange={setFormData}
                    tenorOptions={tenorOptions}
                    downPaymentOptions={downPaymentOptions} />

                  </div>

                  <div className="flex flex-col sm:flex-row gap-3 justify-center">
                    <Button
                    variant="outline"
                    size="lg"
                    iconName="ArrowLeft"
                    iconPosition="left"
                    onClick={() => setCurrentStep(1)}>

                      Kembali
                    </Button>
                    <Button
                    variant="default"
                    size="lg"
                    iconName="Calculator"
                    iconPosition="right"
                    onClick={calculateSimulation}
                    disabled={!formData?.downPayment || !formData?.tenor || !formData?.fullName || !formData?.phone}
                    className="shadow-honda-subtle">

                      Hitung Simulasi
                    </Button>
                  </div>
                </div>
              }

              {currentStep === 3 && simulationResult &&
              <div className="bg-card border border-border rounded-lg p-6 md:p-8">
                  <SimulationResult
                  result={simulationResult}
                  onWhatsAppConsult={handleWhatsAppConsult}
                  onReset={handleReset} />

                </div>
              }
            </div>
          </div>
        </section>

        <section className="py-12 md:py-16 lg:py-20 bg-muted">
          <div className="container mx-auto px-4">
            <div className="max-w-6xl mx-auto space-y-12">
              <RequiredDocuments documents={requiredDocuments} />
              <FAQSection faqs={faqs} />
            </div>
          </div>
        </section>

        <section className="py-12 md:py-16 lg:py-20 bg-gradient-to-br from-primary to-accent text-primary-foreground">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto text-center space-y-6" data-aos="fade-up" data-aos-delay="200">
              <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-primary-foreground/10 mb-4">
                <Icon name="MessageCircle" size={32} color="white" strokeWidth={2} />
              </div>
              <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold">
                Butuh Bantuan Lebih Lanjut?
              </h2>
              <p className="text-base md:text-lg text-primary-foreground/90 max-w-2xl mx-auto">
                Tim sales kami siap membantu Anda menemukan paket kredit terbaik 
                sesuai kebutuhan dan budget. Konsultasi gratis via WhatsApp!
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center pt-4">
                <Button
                  variant="outline"
                  size="lg"
                  iconName="Phone"
                  iconPosition="left"
                  onClick={() => window.open('tel:+6288293642972', '_blank')}
                  className="bg-primary-foreground text-primary hover:bg-primary-foreground/90">

                  Hubungi Kami
                </Button>
                <Button
                  variant="default"
                  size="lg"
                  iconName="MessageCircle"
                  iconPosition="left"
                  onClick={() => window.open('https://wa.me/6288293642972', '_blank')}
                  className="bg-primary-foreground text-primary hover:bg-primary-foreground/90 shadow-honda-subtle">

                  Chat WhatsApp
                </Button>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>);

};

export default CreditSimulation;